import { client } from './client'

const fetchCheckoutRedirectConfig = async () => {
  try {
    let response = await client.get('/api/checkoutRedirect')
    return response.data
  } catch (error) {
    throw error
  }
}

export {
  fetchCheckoutRedirectConfig
}



// WEBPACK FOOTER //
// ./src/api/vercelServerless/index.js